import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getXeroOrganizations = (apiKeys: string) => {
    return axiosPrivate.get(`/dashboard/api/v1/xero/connections?api_key=${apiKeys}`)
}